import { useEffect, useState } from "react"
import { BrowserRouter, Route, Routes, Navigate, Outlet } from "react-router-dom";
import Navbar from "../components/main/navbar/navbar";
import Sidebar from "../components/main/sidebar/sidebar";
import Login from "../components/main/login/login";
import Dashboard from "../components/main/dashboard/main";
import ParBack from "../components/design/particles_background";
import { decryptData, encryptData } from "../utils/crypt";
import { toast, Toaster } from 'react-hot-toast';
import BarangPage from "./barang";
import CustomerPage from "./customer";
import PrivateRoute from "../private_route";
import PublicRoute from "../public_routes";
import AdminPage from "./admin";
import Home from "./home";
import About from "./about";
import Services from "./services";
import Contact from "./contact";
import CheckRates from "./check-rates";
import MainTracking from "./tracking";
import PageTransition from "../components/main/PageTransition";

const AdminLayout = ({ nickname, onLogout, roleAccess, username, isLoggedIn }) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className="admin-root-layout">
      <ParBack />
      {isLoggedIn && (
        <Sidebar
          nickname={nickname}
          onLogout={onLogout}
          roleAccess={roleAccess}
          username={username}
          mobileOpen={mobileOpen}
          setMobileOpen={setMobileOpen}
          collapsed={collapsed}
          setCollapsed={setCollapsed}
        />
      )}
      <div className={`admin-main-wrapper ${collapsed ? "sidebar-collapsed" : ""}`}>
        {isLoggedIn && (
          <Navbar
            nickname={nickname}
            roleAccess={roleAccess}
            mobileOpen={mobileOpen}
            setMobileOpen={setMobileOpen}
            collapsed={collapsed}
            setCollapsed={setCollapsed}
          />
        )}
        <main className="admin-page-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default function MainRoute(){
    const [timeoutId, setTimeoutId] = useState(null);
    const [isLoggedIn, setIsLoggedIn] = useState(localStorage.getItem('isLoggedIn') === 'true');
    const [username, setUserName] = useState('');
    const [nickname, setNickname] = useState('');
    const [roleAccess, setRoleAccess] = useState('');
    // console.log(id)
    const handleLogin = ({ username, nama, roleAccess }) => {
        setIsLoggedIn(true);
        setUserName(username);
        setNickname(nama);
        setRoleAccess(roleAccess);
        localStorage.setItem('username', encryptData(username));
        localStorage.setItem('nickname', encryptData(nama));
        localStorage.setItem('roleAccess', encryptData(roleAccess))
        localStorage.setItem('isLoggedIn', 'true');
        const newTimeoutId = setTimeout(() => {
            handleLogout();
        }, 3600000);
        setTimeoutId(newTimeoutId);
        toast(`Hi!, ${nama}`, {
        duration: 6000,
        icon: '👋'
        })
    };
    const handleLogout = () => {
        setIsLoggedIn(false);
        setUserName('');
        setNickname('');
        localStorage.removeItem('token');
        localStorage.removeItem('username');
        localStorage.removeItem('nickname');
        localStorage.removeItem('isLoggedIn');
        localStorage.removeItem('roleAccess');
        localStorage.setItem('isLoggedIn', 'false');
        clearTimeout(timeoutId);
    };
    // const storedTimeoutId = setTimeout(() => {
    //     handleLogout();
    // }, 3600000);
    useEffect(() => {
        const isLoggedInLocalStorage = localStorage.getItem('isLoggedIn');
        if (isLoggedInLocalStorage === 'true') {
            setIsLoggedIn(true);
            setUserName(decryptData(localStorage.getItem('username')));
            setNickname(decryptData(localStorage.getItem('nickname')));
            setRoleAccess(decryptData(localStorage.getItem('roleAccess')));
        }
    }, []);

    // useEffect(() => {
    //     if (storedTimeoutId) {
    //         setTimeoutId(storedTimeoutId);
    //     }
    // }, [storedTimeoutId]);

    return(
        <BrowserRouter>
            <PageTransition />
            <Toaster position="top-center" />
            <Routes>
                {/* PUBLIC ROUTES */}
                <Route path="/" element={<Home />} />
                <Route
                    path="/about"
                    element={
                        <PublicRoute isLoggedIn={isLoggedIn}>
                            <About />
                        </PublicRoute>
                    }
                />
                <Route
                    path="/services"
                    element={
                        <PublicRoute isLoggedIn={isLoggedIn}>
                            <Services />
                        </PublicRoute>
                    }
                />
                <Route
                    path="/contact"
                    element={
                        <PublicRoute isLoggedIn={isLoggedIn}>
                            <Contact />
                        </PublicRoute>
                    }
                />
                <Route
                    path="/check-rates"
                    element={
                        <PublicRoute isLoggedIn={isLoggedIn}>
                            <CheckRates />
                        </PublicRoute>
                    }
                />
                <Route
                    path="/login"
                    element={
                        <PublicRoute isLoggedIn={isLoggedIn}>
                            <Login onLogin={handleLogin} />
                        </PublicRoute>
                    }
                />
                <Route
                    path="/tracking"
                    element={
                        <PublicRoute isLoggedIn={isLoggedIn}>
                            <MainTracking />
                        </PublicRoute>
                    }
                />
                <Route
                    path="/tracking/:kodePengiriman/:noResiParam"
                    element={
                        <PublicRoute isLoggedIn={isLoggedIn}>
                            <MainTracking />
                        </PublicRoute>
                    }
                />

                {/* ADMIN/PRIVATE ROUTES NESTED UNDER ADMIN LAYOUT */}
                <Route element={<AdminLayout nickname={nickname} onLogout={handleLogout} roleAccess={roleAccess} username={username} isLoggedIn={isLoggedIn} />}>
                    <Route
                        path="/admin/dashboard"
                        element={
                            <PrivateRoute isLoggedIn={isLoggedIn}>
                                <Dashboard />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/admin/list-barang"
                        element={
                            <PrivateRoute isLoggedIn={isLoggedIn}>
                                <BarangPage />
                            </PrivateRoute>
                        }
                    />

                    <Route
                        path="/admin/list-customer"
                        element={
                            <PrivateRoute isLoggedIn={isLoggedIn}>
                                <CustomerPage />
                            </PrivateRoute>
                        }
                    />
                    {roleAccess === "Master" || roleAccess === "DBA" ? (
                        <Route
                            path="/admin/list-karyawan"
                            element={
                                <PrivateRoute isLoggedIn={isLoggedIn}>
                                    <AdminPage />
                                </PrivateRoute>
                            }
                        />
                    ) : null}
                </Route>

                <Route
                    path="*"
                    element={<Navigate to={isLoggedIn ? "/admin/dashboard" : "/"} replace />}
                />
            </Routes>
        </BrowserRouter>
    )
}